module.exports = __webpack_public_path__ + "static/img/logo.4ae82a06.png";